import { useEffect, useState, useCallback } from 'react';

type SetSelectedSnap = (value: number) => void;
type SetGalleryActive = (value: boolean) => void;

interface EmblaCarouselApi {
  scrollSnapList: () => number[];
  selectedScrollSnap: () => number;
  on: (event: string, callback: () => void) => void;
}

export const useEmblaApi = (
  emblaApi: EmblaCarouselApi | undefined,
  setSelectedSnap: SetSelectedSnap,
  setGalleryActive: SetGalleryActive,
): { snapCount: number } => {
  const [snapCount, setSnapCount] = useState(0);

  const updateScrollSnapState = useCallback(() => {
    if (!emblaApi) return;
    setSnapCount(emblaApi.scrollSnapList().length);
    setSelectedSnap(emblaApi.selectedScrollSnap());
    setGalleryActive(emblaApi.selectedScrollSnap() > 0);
  }, [emblaApi, setSelectedSnap]);

  useEffect(() => {
    if (!emblaApi) return;

    updateScrollSnapState();
    emblaApi.on('select', updateScrollSnapState);
    emblaApi.on('reInit', updateScrollSnapState);
  }, [emblaApi, updateScrollSnapState]);

  return { snapCount };
};
